import React from "react"
import Modal from "../../UI/Modal/Modal"
import classes from "../AdminForm.module.css"
import { Controller, useFieldArray, useForm } from "react-hook-form"
import Field from "../../UI/Field/Field"
import Input from "../../UI/Form/Input"
import { useEffect, useState } from "react"
import CustomButton from "../../UI/CustomButton/CustomButton"
import { AiOutlinePlus } from "react-icons/ai"
import StageSection from "./StageSection/StageSection"
import DropZone from "../../Common/DropZone/DropZone"
import moment from "moment"
import CustomMarkdown from "../../UI/Form/Markdown/CustomMarkdown"
import CustomAutocomplete from "../../UI/Form/CustomAutocmplete"
import CustomCheckbox from "../../UI/Form/CustomCheckbox"
import FaqSection from "./FaqSection/FaqSection"
import { cx } from "../../../Utils/classnames"
import AddTicketType from "./AddTicketType/AddTicketType"
import { IconButton, MenuItem } from "@mui/material"
import { AiOutlineClose } from 'react-icons/ai';
import { MdModeEdit, MdDeleteForever } from 'react-icons/md';
import EditTicketType from "./AddTicketType/EditTicketType"
import AdminDeleteModal from "../../UI/Admin/AdminDeleteModal/AdminDeleteModal"
import DateSection from "./DateSection/DateSection"
import DaySection from "./DaySection/DaySection"
import CustomSelect from "../../UI/Form/CustomSelect"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"

const EditEvent = (props) => {
    const { onClose, editEvent, event, partners, residents, promocodes, getTicketTypes, setTicketTypesData, ticketTypes, deleteTicketType, howItWas } = props

    const { handleSubmit, reset, control, setValue, watch } = useForm()

    const [isOpenAddTicketTypeModal, setIsOpenAddTicketTypeModal] = useState(false)
    const [isOpenEditTicketTypeModal, setIsOpenEditTicketTypeModal] = useState(false)
    const [isOpenDeleteTicketTypeModal, setIsOpenDeleteTicketTypeModal] = useState(false)
    const [currentTicketType, setCurrentTicketType] = useState(null)
    const [selectedTicketTypes, setSelectedTicketTypes] = useState([])

    const {
        fields: dates,
        append: dateAppend,
        remove: dateRemove
    } = useFieldArray({ control, name: "dates" })

    const addDate = () => {
        dateAppend({})
    }

    const removeDate = (index) => {
        if (dates.length > 1) {
            dateRemove(index)
        }
    }

    const {
        fields: lineup,
        append: dayAppend,
        remove: dayRemove
    } = useFieldArray({ control, name: "lineup" })

    const addDay = () => {
        dayAppend({})
    }

    const removeDay = (index) => {
        if (lineup.length > 1) {
            dayRemove(index)
        }
    }

    const {
        fields: faq,
        append: faqAppend,
        remove: faqRemove
    } = useFieldArray({ control, name: 'faq' })

    const addFaq = () => {
        faqAppend({ })
    }

    const removeFaq = (index) => {
        faqRemove(index)
    }

    console.log(ticketTypes)

    const onDragEnd = result => {
        if (!result.destination) return
        const newSelectedTicketTypes = [ ...selectedTicketTypes ]

        const tmpTicketType = newSelectedTicketTypes[result.destination.index]

        newSelectedTicketTypes[result.destination.index] = newSelectedTicketTypes[result.source.index]
        newSelectedTicketTypes[result.source.index] = tmpTicketType

        setSelectedTicketTypes(newSelectedTicketTypes)
    }

    const handleOpenAddTicketTypeModal = () => {
        setIsOpenAddTicketTypeModal(!isOpenAddTicketTypeModal)
    }

    const handleClickTicketType = (ticketType) => {
        if (selectedTicketTypes.find(el => el._id === ticketType._id)) {
            const newSelectedTicketTypes = selectedTicketTypes.filter(el => el._id !== ticketType._id)
            setSelectedTicketTypes(newSelectedTicketTypes)
        } else {
            setSelectedTicketTypes([ ...selectedTicketTypes, ticketType ])
        }
    }

    const handleEditTicketType = (e, ticketType) => {
        e.stopPropagation()
        setIsOpenEditTicketTypeModal(true)
        setCurrentTicketType(ticketType)
    }

    const handleDeleteTicketType = (e, ticketType) => {
        e.stopPropagation()
        setIsOpenDeleteTicketTypeModal(true)
        setCurrentTicketType(ticketType)
    }

    const handleRemoveTicketType = () => {
        deleteTicketType(currentTicketType._id).then(response => {
            if (response) {
                setTicketTypesData(ticketTypes.filter(el => el._id !== currentTicketType._id))
            }
        })
    }

    const handleOpenRemoveTicketType = () => {
        setIsOpenDeleteTicketTypeModal(false)
        setCurrentTicketType(null)
    }

    const onSubmit = (data) => {
        const ticketTypesIds = selectedTicketTypes.map(el => el._id)

        if (data.image_on_ticket_form.length === 0) {
            data.image_on_ticket_form = ""
        }
        if (data.light_show_concept === 0) {
            data.light_show_concept = ""
        }
        
        if (data.promocode_id && data.promocode_id._id) {
            editEvent(event._id, {
                ...data,
                promocode_id: data.promocode_id._id,
                price: ticketTypesIds
            })
        } else {
            editEvent(event._id, {
                ...data,
                price: ticketTypesIds
            })
        }
    }

    const onError = (errors) => {
        const firstErrorField = Object.keys(errors)[0]; // "date", "endDate" и т.д.
      
        const fieldElement = document.querySelector(`[name="${firstErrorField}"]`);
        if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    useEffect(() => {
        if (event) {
            getTicketTypes(event._id)
        }
    }, [event])

    useEffect(() => {
        return () => {
            setTicketTypesData([])
        }
    }, [])

    useEffect(() => {
        const dates = event?.dates?.map(el => {
            return {
                ...el,
                date: moment(el.date)
            }
        })

        reset({
            title: event.title,
            title_code: event.title_code,
            dates: dates,
            date: moment(event.date),
            endDate: event.endDate ? moment(event.endDate) : null,
            start: event.start,
            end: event.end,
            address: event.address,
            address_en: event.address_en,
            venue: event.venue,
            city: event.city,
            city_en: event.city_en,
            pricing: event.pricing,
            lineup: event.lineup,
            description: event.description,
            description_en: event.description_en,
            main_keys: event.main_keys,
            main_keys_en: event.main_keys_en,
            keywords: event.keywords,
            faq: event.faq,
            poster: {
                image: event.poster.image,
                video: event.poster.video
            },
            partners: event.partners,
            is_featured: event.is_featured,
            is_unique_design: event.is_unique_design,
            image_on_ticket_form: event.image_on_ticket_form ? [event.image_on_ticket_form] : [],
            promocodes: promocodes.filter(el => el._id === event.promocodes.find(promocode => promocode === el._id)) || null,
            is_multi_buy: event.is_multi_buy,
            google_table_id: event.google_table_id,
            location_scheme: event.location_scheme,
            light_show_concept: event.light_show_concept,
            howItWas: event.howItWas
        })
        if (event.price) {
            setSelectedTicketTypes(event.price)
        }
    }, [event])

    return (
        <Modal title={`Edit Event ${event.title}`} onClose={onClose}>
            {isOpenAddTicketTypeModal && (
                <AddTicketType
                    onClose={handleOpenAddTicketTypeModal}
                    eventId={event._id}    
                    setTicketTypesData={setTicketTypesData}                
                    ticketTypes={ticketTypes}
                    event={event}
                />
            )}
            {isOpenEditTicketTypeModal && (
                <EditTicketType
                    onClose={() => setIsOpenEditTicketTypeModal(false)}
                    eventId={event._id}    
                    setTicketTypesData={setTicketTypesData}                
                    ticketTypes={ticketTypes}
                    currentTicketType={currentTicketType}
                    event={event}
                />
            )}
            {isOpenDeleteTicketTypeModal && (
                <AdminDeleteModal
                    deleteItem={handleRemoveTicketType}
                    onClose={() => setIsOpenDeleteTicketTypeModal(false)}
                    onRemove={handleOpenRemoveTicketType}
                    item={currentTicketType}
                    name={currentTicketType.name}
                />
            )}
            <form className={classes.main} onSubmit={handleSubmit(onSubmit, onError)}>
                <Field>
                    <Controller
                        name="title"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Required Field!" }}
                        render={({
                            field: { onChange, value, name },
                            fieldState: { error }
                        }) => (
                            <Input
                                name={name}
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="Title"
                            />
                        )}
                    />
                    <Controller
                        name="title_code"
                        control={control}
                        defaultValue=""
                        render={({
                            field: { onChange, value, name },
                            fieldState: { error }
                        }) => (
                            <Input
                                name={name}
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="URL code (optional, if empty will generate automaticaly)"
                            />
                        )}
                    />
                </Field>
                <Field direction="column">
                    <Field className={classes.sectionHeader}>
                        <h3>Date</h3>
                        <CustomButton
                            className={classes.addBut}
                            onClick={addDate}
                        >
                            <AiOutlinePlus />
                            <span>Add New Date</span>
                        </CustomButton>
                    </Field>
                    {dates.map((el, index) => (
                        <DateSection
                            index={index}
                            control={control}
                            onRemove={removeDate}
                            key={el.id}
                        />
                    ))}
                    <br/>
                </Field>
                <Field>
                    <Controller
                        name="city"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Required Field!" }}
                        render={({
                            field: { onChange, value, name },
                            fieldState: { error }
                        }) => (
                            <Input
                                name={name}
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="City"
                            />
                        )}
                    />
                    <Controller
                        name="city_en"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Required Field!" }}
                        render={({
                            field: { onChange, value, name },
                            fieldState: { error }
                        }) => (
                            <Input
                                name={name}
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="City (EN)"
                            />
                        )}
                    />
                </Field>
                <Controller
                    name="venue"
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <Input
                            onChange={onChange}
                            value={value}
                            error={error}
                            label="Venue"
                        />
                    )}
                />
                <Field>
                    <Controller
                        name="address"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Required Field!" }}
                        render={({
                            field: { onChange, value, name },
                            fieldState: { error }
                        }) => (
                            <Input
                                name={name}
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="Address"
                            />
                        )}
                    />
                    <Controller
                        name="address_en"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Required Field!" }}
                        render={({
                            field: { onChange, value, name },
                            fieldState: { error }
                        }) => (
                            <Input
                                name={name}
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="Address (EN)"
                            />
                        )}
                    />
                </Field>
                <Controller
                    name="poster.video"
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <Input
                            onChange={onChange}
                            value={value}
                            error={error}
                            label="Video Teaser (YouTube Link)"
                        />
                    )}
                />
                <div className={classes.imgContainer}>
                    <Controller
                        name={`poster.image`}
                        control={control}
                        rules={{ required: "Required Field!" }}
                        defaultValue=""
                        render={({
                            field: { onChange, value },
                            fieldState: { error }
                        }) => (
                            <>
                                <DropZone
                                    onChange={onChange}
                                    error={error}
                                    title="Poster Image"
                                    id={1}
                                    initialFiles={[value]}
                                />
                            </>
                        )}
                    />
                </div>
                <Field className={classes.sectionHeader}>
                    <h3>Pricing</h3>
                    <CustomButton
                        className={classes.addBut}
                        onClick={handleOpenAddTicketTypeModal}
                    >
                        <AiOutlinePlus />
                        <span>Add new Ticket Type</span>
                    </CustomButton>
                </Field>
                <Field>
                    <div className={classes.selectedPriceCategories}>
                        <span>Selected</span>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="content">
                                {(provided) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        className={classes.drag}
                                    >
                                        {selectedTicketTypes.map((el, index) => (
                                            <Draggable
                                                key={el._id}
                                                draggableId={el._id}
                                                index={index}
                                            >
                                                {(prov) => (
                                                    <div ref={prov.innerRef} {...prov.draggableProps} style={{ ...prov.draggableProps.style }} className={classes.priceContainer}>
                                                        <span
                                                            {...prov.dragHandleProps}
                                                            style={{ cursor: "grab" }}
                                                        >
                                                            ☰
                                                        </span>
                                                        <span className={classes.ticketName}>{el.name}</span>
                                                        <div className={classes.pricingButtons}>
                                                            <IconButton onClick={(e) => handleEditTicketType(e, el)}>
                                                                <MdModeEdit/>
                                                            </IconButton>
                                                            <IconButton onClick={() => handleClickTicketType(el)}>
                                                                <AiOutlineClose/>
                                                            </IconButton>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                    <div className={classes.allPriceCategories}>
                        <span>Available</span>
                        {ticketTypes.filter(type => !selectedTicketTypes.some(sel => sel._id === type._id)).map(type => (
                            <div
                                className={classes.priceContainer}
                                key={type._id}
                                onClick={() => handleClickTicketType(type)}
                            >
                                <span className={classes.ticketName}>{type.name}</span>
                                <div className={classes.pricingButtons}>
                                    <IconButton onClick={(e) => handleEditTicketType(e, type)}>
                                        <MdModeEdit/>
                                    </IconButton>
                                    <IconButton onClick={(e) => handleDeleteTicketType(e, type)}>
                                        <MdDeleteForever/>
                                    </IconButton>
                                </div>
                            </div>    
                        ))}
                    </div>
                </Field>
                <Field direction="column">
                    <Field className={classes.sectionHeader}>
                        <h3>Line up</h3>
                        <CustomButton
                            className={classes.addBut}
                            onClick={addDay}
                        >
                            <AiOutlinePlus />
                            <span>Add New Day</span>
                        </CustomButton>
                    </Field>
                    {lineup.map((el, index) => (
                        <DaySection
                            index={index}
                            control={control}
                            onRemove={removeDay}
                            key={el.id}
                            residents={residents}
                        />
                    ))}
                </Field>
                <Controller
                    name="description"
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <CustomMarkdown
                            value={value}
                            onChange={onChange}
                            label={"Description"}
                        />
                    )}
                />
                <Controller
                    name="description_en"
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <CustomMarkdown
                            value={value}
                            onChange={onChange}
                            label={"Description (EN)"}
                        />
                    )}
                />
                <Controller
                    name="main_keys"
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <CustomMarkdown
                            value={value}
                            onChange={onChange}
                            label={"Main Keys"}
                        />
                    )}
                />
                <Controller
                    name="main_keys_en"
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <CustomMarkdown
                            value={value}
                            onChange={onChange}
                            label={"Main Keys (EN)"}
                        />
                    )}
                />
                <Field>
                    <Controller
                        name="keywords"
                        control={control}
                        defaultValue=""
                        render={({
                            field: { onChange, value },
                            fieldState: { error }
                        }) => (
                            <Input
                                onChange={onChange}
                                value={value}
                                multiline
                                placeholder="Write inline (electroperedachi, techno, etc)"
                                label="Keywords (for SEO)"
                            />
                        )}
                    />
                </Field>
                <div className={classes.imgContainer}>
                    <Controller
                        name={`location_scheme`}
                        control={control}
                        defaultValue=""
                        render={({
                            field: { onChange, value },
                            fieldState: { error }
                        }) => (
                            <>
                                <DropZone
                                    multiple={true}
                                    onChange={onChange}
                                    error={error}
                                    title="Location Scheme photos"
                                    id={5}
                                    initialFiles={value}
                                />
                            </>
                        )}
                    />
                </div>
                <div className={classes.imgContainer}>
                    <Controller
                        name={`light_show_concept`}
                        control={control}
                        defaultValue=""
                        render={({
                            field: { onChange, value, name },
                            fieldState: { error }
                        }) => (
                            <>
                                <DropZone
                                    name={name}
                                    onChange={onChange}
                                    error={error}
                                    title="Light Show Concept (photo / video)"
                                    id={4}
                                    initialFiles={[value]}
                                />
                            </>
                        )}
                    />
                </div>
                <Controller
                    name="howItWas"
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <CustomSelect
                            error={error}
                            value={value}
                            onChange={onChange}
                            label="How it Was Section"
                        >
                            {howItWas.map(el => (
                                <MenuItem key={el._id} value={el._id}>{el.title}</MenuItem>
                            ))}
                        </CustomSelect>
                    )}
                />
                <Field direction="column">
                    <Field className={classes.sectionHeader}>
                        <h3>FAQ</h3>
                    </Field>
                    {faq.map((el, index) => (
                        <FaqSection  
                            index={index} 
                            control={control} 
                            onRemove={removeFaq}
                            key={el.id}
                        />
                    ))}
                </Field>
                <Field>
                    <CustomButton className={cx(classes.addBut, classes.addFaq)} onClick={addFaq}>
                        <AiOutlinePlus/>
                        <span>Add FAQ section</span>
                    </CustomButton>
                </Field>
                <div style={{ marginTop: "10px" }}>
                    <Controller
                        name={"partners"}
                        control={control}
                        defaultValue={[]}
                        render={({
                            field: { onChange, value },
                            fieldState: { error }
                        }) => (
                            <CustomAutocomplete
                                value={value}
                                onChange={onChange}
                                items={partners}
                                multiple={true}
                                label={"Partners"}
                                error={error}
                                setValue={setValue}
                                name={"partners"}
                            />
                        )}
                    />
                </div>
                <Controller
                    name="is_featured"
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <CustomCheckbox
                            checked={value}
                            onChange={onChange}
                            label="Is Featured"
                        />
                    )}
                />
                <Controller
                    name="is_unique_design"
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <CustomCheckbox
                            checked={value}
                            onChange={onChange}
                            label="Have a Custom Landing Page"
                        />
                    )}
                />
                <Controller
                    name="google_table_id"
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <Input
                            onChange={onChange}
                            value={value}
                            error={error}
                            label="Google table ID"
                        />
                    )}
                />
                <Controller
                    name={"image_on_ticket_form"}
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <>
                            <DropZone
                                onChange={onChange}
                                error={error}
                                title="Image for ticket buy section (will placed default img if empty)"
                                id={3}
                                initialFiles={value}
                            />
                        </>
                    )}
                />
                <div style={{ marginTop: "10px" }}>
                    <Controller
                        name={"promocodes"}
                        control={control}
                        defaultValue={[]}
                        render={({
                            field: { onChange, value },
                            fieldState: { error }
                        }) => (
                            <CustomAutocomplete
                                value={value}
                                onChange={onChange}
                                items={promocodes}
                                multiple={true}
                                label={"Promocode"}
                                error={error}
                                setValue={setValue}
                                name={"promocodes"}
                            />
                        )}
                    />
                </div>
                <Controller
                    name="is_multi_buy"
                    control={control}
                    defaultValue=""
                    render={({
                        field: { onChange, value },
                        fieldState: { error }
                    }) => (
                        <CustomCheckbox
                            checked={value}
                            onChange={onChange}
                            label="Multi Buy Action"
                        />
                    )}
                />
                <CustomButton type="submit">Save</CustomButton>
            </form>
        </Modal>
    )
}

export default EditEvent
